import React, { useCallback } from 'react';

import { AspectRatio } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { EventName, emitEvent } from 'utils/event-hub';

import { CTAButtons } from '../components/cta-button';
import { ISimpleHomePageProps } from '../types';

import { ButtonsContainer, HeaderContainer, HeaderStyled, HeroSection } from './styled';

const _SimpleHomePageMobile = ({
  height,
  navigate,
  numberOfItemsInCart,
  serviceMode,
  item,
}: ISimpleHomePageProps) => {
  const { header, mobileImage, altImageText, _id } = item;
  const headerText = header?.locale ?? '';
  const imageAlt = altImageText?.locale ?? '';
  const image = mobileImage?.locale;

  const onImageLoaded = useCallback(() => {
    emitEvent(EventName.MARKETING_IMAGE_LOADED);
  }, []);

  return (
    <HeroSection testID="simple-home-page" minHeight={height}>
      <HeaderContainer accessibilityLabel={headerText}>
        <HeaderStyled>{headerText}</HeaderStyled>
      </HeaderContainer>
      <AspectRatio>
        <Picture height="full" image={image} alt={imageAlt} onImageLoaded={onImageLoaded} />
      </AspectRatio>
      <ButtonsContainer>
        <CTAButtons
          numberOfItemsInCart={numberOfItemsInCart}
          serviceMode={serviceMode}
          navigate={navigate}
          itemId={_id}
        />
      </ButtonsContainer>
    </HeroSection>
  );
};

export const SimpleHomePageMobile = React.memo(_SimpleHomePageMobile);
